/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CustomerSegmentsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CustomerSegmentsQuery = { __typename?: 'Query' } & {
  GetCustomerSegments: Types.Maybe<
    { __typename?: 'CustomerSegments' } & {
      b2b_intention: Types.CustomerSegments['b2bIntention'];
      b2b_welcome: Types.CustomerSegments['b2bWelcome'];
      b2b_vat_modal: Types.CustomerSegments['b2bVatModal'];
      b2b_suspected_pro: Types.CustomerSegments['b2bSuspectedPro'];
      suspected_pro_type: Types.CustomerSegments['suspectedProType'];
      profile: Types.CustomerSegments['profile'];
      cluster: Types.CustomerSegments['cluster'];
      buy_number_cluster: Types.CustomerSegments['buyNumberCluster'];
      audience_group: Types.CustomerSegments['audienceGroup'];
      loyalty_level: Types.CustomerSegments['loyaltyLevel'];
      loyalty_hvc_level: Types.CustomerSegments['loyaltyHVCLevel'];
      app_cluster: Types.CustomerSegments['appCluster'];
      last_chance_churn: Types.CustomerSegments['lastChanceChurn'];
      anti_churn: Types.CustomerSegments['antiChurn'];
      b2b_subscription: Types.CustomerSegments['b2bSubscription'];
      customer_value: Types.CustomerSegments['customerValue'];
    }
  >;
};

export const CustomerSegmentsDocument = /*#__PURE__*/ `
    query CustomerSegments {
  GetCustomerSegments {
    b2b_intention: b2bIntention
    b2b_welcome: b2bWelcome
    b2b_vat_modal: b2bVatModal
    b2b_suspected_pro: b2bSuspectedPro
    suspected_pro_type: suspectedProType
    profile: profile
    cluster: cluster
    buy_number_cluster: buyNumberCluster
    audience_group: audienceGroup
    loyalty_level: loyaltyLevel
    loyalty_hvc_level: loyaltyHVCLevel
    app_cluster: appCluster
    last_chance_churn: lastChanceChurn
    anti_churn: antiChurn
    b2b_subscription: b2bSubscription
    customer_value: customerValue
  }
}
    `;

export function useCustomerSegmentsQuery(
  options?: Omit<Urql.UseQueryArgs<CustomerSegmentsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CustomerSegmentsQuery, CustomerSegmentsQueryVariables>({
    query: CustomerSegmentsDocument,
    ...options,
  });
}
